import {
  RATE_LIST,
  RATE_CREATE,
  RATE_UPDATE,
  RATE_DELETE,
  RATE_UPDATE_SUCCESS,
  RATE_CREATE_SUCCESS,
  RATE_DELETE_SUCCESS,
  RATE_LIST_SUCCESS,
  RATE_REQUEST_FAILED,
  RATE_FILTER,
} from "store/rates/actionTypes";

const initialState = {
  rates: [],
  rateCreated: {},
  rateUpdated: {},
  rateDeleted: false,
  loading: false,
  error: "",
};

const rate = (state = initialState, action) => {
  switch (action.type) {
    case RATE_LIST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case RATE_CREATE:
      state = {
        ...state,
        loading: true,
      };
      break;
    case RATE_UPDATE:
      state = {
        ...state,
        loading: true,
      };
      break;
    case RATE_DELETE:
      state = {
        ...state,
        loading: true,
      };
      break;
    case RATE_FILTER:
      state = {
        ...state,
        loading: true,
      };
      break;
    case RATE_LIST_SUCCESS:
      state = {
        ...state,
        loading: false,
        rates: action.payload,
        rateCreated: {},
        rateUpdated: {},
        rateDeleted: false,
        error: "",
      };
      break;
    case RATE_CREATE_SUCCESS:
      state = {
        ...state,
        loading: false,
        rateCreated: action.payload,
        error: "",
      };
      break;
    case RATE_UPDATE_SUCCESS:
      state = {
        ...state,
        loading: false,
        rateUpdated: action.payload,
        error: "",
      };
      break;
    case RATE_DELETE_SUCCESS:
      state = {
        ...state,
        loading: false,
        rateDeleted: true,
        error: "",
      };
      break;
    case RATE_REQUEST_FAILED:
      state = {
        ...state,
        loading: false,
        error: action.payload,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default rate;
